import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LoanCollateralController::store
* @see app/Http/Controllers/LoanCollateralController.php:13
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals'
*/
export const store = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\LoanCollateralController::store
* @see app/Http/Controllers/LoanCollateralController.php:13
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals'
*/
store.url = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            loan: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        loan: typeof args.loan === 'object'
        ? args.loan.id
        : args.loan,
    }

    return store.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{loan}', parsedArgs.loan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoanCollateralController::store
* @see app/Http/Controllers/LoanCollateralController.php:13
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals'
*/
store.post = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LoanCollateralController::update
* @see app/Http/Controllers/LoanCollateralController.php:24
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
export const update = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\LoanCollateralController::update
* @see app/Http/Controllers/LoanCollateralController.php:24
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
update.url = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            loan: args[1],
            collateral: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        loan: typeof args.loan === 'object'
        ? args.loan.id
        : args.loan,
        collateral: typeof args.collateral === 'object'
        ? args.collateral.id
        : args.collateral,
    }

    return update.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{loan}', parsedArgs.loan.toString())
            .replace('{collateral}', parsedArgs.collateral.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoanCollateralController::update
* @see app/Http/Controllers/LoanCollateralController.php:24
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
update.put = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\LoanCollateralController::update
* @see app/Http/Controllers/LoanCollateralController.php:24
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
update.patch = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\LoanCollateralController::destroy
* @see app/Http/Controllers/LoanCollateralController.php:33
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
export const destroy = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\LoanCollateralController::destroy
* @see app/Http/Controllers/LoanCollateralController.php:33
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
destroy.url = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            loan: args[1],
            collateral: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        loan: typeof args.loan === 'object'
        ? args.loan.id
        : args.loan,
        collateral: typeof args.collateral === 'object'
        ? args.collateral.id
        : args.collateral,
    }

    return destroy.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{loan}', parsedArgs.loan.toString())
            .replace('{collateral}', parsedArgs.collateral.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoanCollateralController::destroy
* @see app/Http/Controllers/LoanCollateralController.php:33
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}/collaterals/{collateral}'
*/
destroy.delete = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number }, collateral: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const LoanCollateralController = { store, update, destroy }

export default LoanCollateralController